import styled from "styled-components";
import { IMAGES } from "../../../constants/images";
import { useState } from "react";
import ContactFormModal from "./ContactFormModal";

export default function ContactFormOpen({ isIncludeGeoData = true }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ContactButton onClick={handleOpen}>
        <img className="img" src={IMAGES.WHITE_EMAIL} alt="email" />
        <span>Contact</span>
      </ContactButton>
      {isOpen && <ContactFormModal handleOpen={handleOpen} isIncludeGeoData={isIncludeGeoData} />}
    </>
  );
}

const ContactButton = styled.button`
  all: unset;
  display: flex;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  border-radius: 100px;
  gap: 10px;
  text-transform: uppercase;
  background-color: rgba(0, 0, 255, 1);
  color: white;
  margin: 0 auto;
  cursor: pointer;
  
  img {
    fill: white;
  }

  @media (max-width: 568px) {
    width: 100%;
  }
`;
